import { CompleteQuery } from 'modules/queryBuilder/types';
import { conditionExistsInQuery } from 'modules/queryBuilder/utils/conditionExistsInQuery';
import { useModalContext } from 'utils/contexts/modal';
import { hasCatalogQuery } from '../utils';

// Add modals to this enum
export enum MODAL_ACTION {
  DELETE_USERS = 'delete-users-in-list',
  EXPORT_TO_CSV = 'export-to-csv',
  EXPORT_TO_FBCA = 'export-to-fbca',
  NEW_DYNAMIC_LIST = 'new-dynamic-list',
  NEW_STATIC_LISTS = 'new-static-lists',
  UPDATE_DYNAMIC_QUERY = 'update-dynamic-query',
}

export interface ModalState {
  action: MODAL_ACTION;
}

export type ModalContextState = {
  showModal: (modalState: ModalState) => void;
  hideModal: () => void;
  modalState: ModalState | null;
};

export const useModalsContext = () => {
  const { showModal, hideModal, modalState } = useModalContext<ModalState>();

  // Put definitions for show[modalName]Modal functions here
  const showDeleteUsersInListModal = () => showModal({ action: MODAL_ACTION.DELETE_USERS });
  const showExportToCSVModal = () => showModal({ action: MODAL_ACTION.EXPORT_TO_CSV });
  const showExportToFBCAModal = () => showModal({ action: MODAL_ACTION.EXPORT_TO_FBCA });
  const showNewDynamicListModal = () => showModal({ action: MODAL_ACTION.NEW_DYNAMIC_LIST });
  const showNewStaticListsModal = () => showModal({ action: MODAL_ACTION.NEW_STATIC_LISTS });
  const showUpdateDynamicListQueryModal = (searchQuery?: CompleteQuery) => {
    if (searchQuery && conditionExistsInQuery(searchQuery, hasCatalogQuery)) return;
    else return showModal({ action: MODAL_ACTION.UPDATE_DYNAMIC_QUERY });
  };

  // Add defined show[modalName]Modal function to return object here
  return {
    hideModal,
    modalState,
    showDeleteUsersInListModal,
    showExportToCSVModal,
    showExportToFBCAModal,
    showNewDynamicListModal,
    showNewStaticListsModal,
    showUpdateDynamicListQueryModal,
  };
};
